import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import { merchantsListKeys } from "Api/Queries/Merchants/useGetMerchantsQuery";
import { deleteMerchantsPublicIDFacilitiesFacilityPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = { publicID: string; facilityPublicID: string };

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteMerchantFacilityMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ publicID, facilityPublicID }: Parameters) =>
        deleteMerchantsPublicIDFacilitiesFacilityPublicID(
          publicID,
          facilityPublicID,
        ),
    ),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: merchantKeys.all }),
        queryClient.invalidateQueries({ queryKey: merchantsListKeys.all }),
      ]);
      onSuccess?.();
    },
    onError,
  });
};
